var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5356 8.70731L16.6496 7.34627L15.6838 8.31204L6.16984 17.826L5.64073 17.2969L15.1547 7.78293L16.1205 6.81716L14.7594 6.93112L8.47647 7.45719C8.25786 7.4755 8.124 7.34164 8.1423 7.12303C8.16606 6.83935 8.43598 6.56942 8.71967 6.54567L17.3058 5.82675C17.5244 5.80844 17.6583 5.9423 17.64 6.16091L16.9211 14.7471C16.8973 15.0308 16.6274 15.3007 16.3437 15.3244C16.1251 15.3427 15.9912 15.2089 16.0095 14.9903L16.5356 8.70731Z",
    stroke: "#675D75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.07574b128e3c789e3cb87b77d35009d3.svg";
export { ForwardRef as ReactComponent };